import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	findProduct({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`product/findProduct`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  save({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`product/save`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findById({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`product/findById`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findProductAndAdditional({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`product/findProductAndAddditional`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
	},
	findEnrolmentByStatus({ commit }, params) {    //获取可变更产品接口
		return new Promise((resolve, reject) => {
			axios.post(`product/findEnrolmentByStatus`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	updateEnrolment({ commit }, params) {    //变更产品接口
		return new Promise((resolve, reject) => {
			axios.post(`product/updateEnrolment`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	selectLeader({ commit }, params) {    //查询负责人
		return new Promise((resolve, reject) => {
			axios.post(`product/selectLeader`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  selectionAndEmpty({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`product/selectionAndEmpty`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},





	// 库存相关
	findOrderStockList({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`order/findOrderStockList`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	}, 
	findOrderStockDetailList({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`order/findOrderStockDetailList`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	findRefundableStock({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`refundStock/findRefundableStock`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	findRefundStock({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`refundStock/findRefundStock`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	}, 
	getOrderDetailById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/onlineOrder/findOnlineOrderById', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
	},
	saveProductStock({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('refundStock/save', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
	},
	submitProductStock({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('refundStock/save', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
	},
	getProductRefundById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get('refundStock/findById', {params}).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
	},
	deleteById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get('refundStock/deleteById', {params}).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
	},
	approve({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('refundStock/approveRefundStockStart', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
	},
	withdraw({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get('refundStock/revokeRefundStock', {params}).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
	},
	getCustomerName({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get('order/getCustomerByOrgId', {params}).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
	},
	saveStockInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('order/saveOrderStock', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
	},
}
